var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseServerDataTable',{ref:"customerContactFilter",attrs:{"extraParams":_vm.extraParams,"setting":_vm.setting,"fnNew":_vm.fnNew,"fnDelete":_vm.$_delete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }